import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { Switch as Switch$1 } from "@base-ui/react/switch";
//#region src/Switch/index.tsx
const rootBaseClassName = "inline-flex shrink-0 cursor-pointer items-center rounded-[10px] border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-default disabled:opacity-50 data-[state=checked]:bg-tertiary-60 data-[state=unchecked]:bg-neutrals-70";
const rootSizeClassName = {
	sm: "h-3 w-5",
	md: "h-5 w-9",
	lg: "h-6 w-11"
};
const thumbBaseClassName = "pointer-events-none block rounded-full bg-white shadow-lg ring-0 transition-transform";
const thumbSizeClassName = {
	sm: "size-2 data-[state=checked]:translate-x-2",
	md: "size-4 data-[state=checked]:translate-x-4",
	lg: "size-5 data-[state=checked]:translate-x-5"
};
const labelClassName = "text-sm text-type-common cursor-pointer select-none";
const wrapperClassName = "flex items-center gap-3";
const Switch = React.forwardRef(({ className, size = "md", label, onCheckedChange, ...props }, ref) => {
	const id = React.useId();
	return /* @__PURE__ */ jsxs("div", {
		className: wrapperClassName,
		children: [/* @__PURE__ */ jsx(Switch$1.Root, {
			className: cn("peer", rootBaseClassName, rootSizeClassName[size], className),
			...props,
			id,
			ref,
			nativeButton: true,
			onCheckedChange: (checked) => onCheckedChange?.(checked),
			render: (rootProps, state) => /* @__PURE__ */ jsx("button", {
				...rootProps,
				"data-state": state.checked ? "checked" : "unchecked",
				type: rootProps.type ?? "button"
			}),
			children: /* @__PURE__ */ jsx(Switch$1.Thumb, {
				className: cn(thumbBaseClassName, thumbSizeClassName[size]),
				render: (thumbProps, state) => /* @__PURE__ */ jsx("span", {
					...thumbProps,
					"data-state": state.checked ? "checked" : "unchecked"
				})
			})
		}), label ? /* @__PURE__ */ jsx("label", {
			className: labelClassName,
			htmlFor: id,
			children: label
		}) : null]
	});
});
Switch.displayName = "Switch";
//#endregion
export { Switch };

//# sourceMappingURL=index.js.map